var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'clsx';
import { customCssClasses } from '@wix/editor-elements-common-utils';
import semanticClassNames from '../../Container.semanticClassNames';
import { ContainerLogic } from './ContainerLogic';
import { TestIds } from './constants';
/** This is a shared dom structure for similar skins */
const BasicContainerComp = (_a, ref) => {
    var { classes, className, customClassNames = [] } = _a, rest = __rest(_a, ["classes", "className", "customClassNames"]);
    return (React.createElement(ContainerLogic, Object.assign({}, rest, { ref: ref, className: classnames(classes.root, className), renderSlot: ({ containerChildren }) => (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classnames(classes.bg, customCssClasses(...customClassNames, semanticClassNames.root)), "data-testid": TestIds.BG }),
            containerChildren)) })));
};
export const BasicContainer = React.forwardRef(BasicContainerComp);
//# sourceMappingURL=BasicContainer.js.map